module.exports = __webpack_public_path__ + "img/mito.281b6e57.jpg";